import {useEffect, useState} from 'react';
import React from "react";
import {useSelector} from "react-redux";
import {NavLink, useNavigate} from "react-router-dom";
import {ListGroup} from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import {discordAuthLink} from "../../config";

const Header = props => {

    const user = useSelector(({UserReducer}) => UserReducer.user);

    const navigate = useNavigate()

    const [isLiveOnKick, setIsLiveOnKick] = useState(false);
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleDiscordLogin = async () => {
        const popupWindow = window.open(
            `${discordAuthLink}`,
            "_blank",
            "width=500, height=700",
        );
        if (window.focus) popupWindow.focus();
    };

    useEffect(() => {
        fetch('https://kick.com/api/v1/channels/kazlic')
            .then((response) => response.json())
            .then((data) => setIsLiveOnKick(data.livestream));
    }, []);

    return (
        <header className="header">
            <div className="container d-flex justify-content-between align-items-center">
                <div className="header-logo d-flex align-items-center gap-3">
                    <NavLink to="/">
                        <img src="/logo.png" alt="logo" className="img-fluid" />
                    </NavLink>
                    {isLiveOnKick && <div className={`streamStatus ${isLiveOnKick ? 'live' : ''}`}>
                        <div className="streamStatusLogo">
                            <div className="ring-container">
                                <div className="ringring"></div>
                                <div className="circle"></div>
                            </div>
                        </div>
                        <div className="streamStatusText"><a target="_blank" href="https://kick.com/kazlic">{isLiveOnKick ? 'LIVE' : ''}</a></div>
                    </div>}
                </div>
                <div className="header-menu d-lg-block d-none">
                    <ul className="pl-0 mb-0 p-0 d-flex align-items-center">
                        <li>
                            <NavLink to="/leaderboard/stake">LEADERBOARD</NavLink>
                        </li>
                        <li>
                            <NavLink to="/rewards">REWARDS</NavLink>
                        </li>
                        {user?.isAdmin && (
                            <li>
                                <NavLink to="/admin">Admin</NavLink>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="header-discord-text d-lg-block d-none">
                    {user ? (
                            <>
                                <div className="headerProfileWrapper">
                                        <a className="headerProfileLink" onClick={() => navigate(`/account`)}>
                                        <img src={user.profileImageUrl} alt="" className="headerProfileImage"/>
                                    </a>
                                </div></>) : (
                        <a className="btn btn-kaz" name="account" onClick={handleDiscordLogin}>
                            <img src="/discord.svg" alt="discord" className="img-fluid" /> Log in
                        </a>
                    )}
                </div>
                <i
                    className="fa-solid fa-bars small-menu-btn d-inline-block d-lg-none ms-auto order-1"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasExample"
                    aria-controls="offcanvasExample"
                    onClick={handleShow}></i>
            </div>

            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ListGroup variant="flush">
                        <ListGroup.Item>
                            <NavLink to="/" onClick={handleClose}>
                                Home
                            </NavLink>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <NavLink to="/leaderboard" onClick={handleClose}>
                                Leaderboard
                            </NavLink>
                        </ListGroup.Item>
                        <ListGroup.Item>
                            <NavLink to="/rewards" onClick={handleClose}>
                                Rewards
                            </NavLink>
                        </ListGroup.Item>

                    </ListGroup>
                </Offcanvas.Body>
            </Offcanvas>
        </header>
    );
}

export default Header;